// @ts-strict-ignore
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Card, DataListItem, RowsSkeletonLoader } from '@node-space/ui-components'
import { Currencies } from 'types/types'

interface MassPayoutBatchInformationProps {
  batchInformation: {
    batchName: string
    totalAmount?: string
    totalAmountCurrency?: string
    totalFee?: string
    totalFeeCurrency?: string
    walletName?: string
    walletNameCurrency?: string
  }
  loading: boolean
}

export const MassPayoutBatchInformation = ({
  batchInformation,
  loading,
}: MassPayoutBatchInformationProps) => {
  const { t } = useTranslation()
  const fiatCurrencies: string[] = [Currencies.EUR, Currencies.GBP]
  const isFiatBatch = fiatCurrencies.includes(batchInformation?.walletNameCurrency)

  const payingFromWallet = isFiatBatch
    ? {
        label: t('massPayouts.payingFromWallet'),
        value: batchInformation?.walletName
          ? `${batchInformation?.walletName} (${batchInformation?.walletNameCurrency})`
          : t('massPayouts.thisWalletIsArchived'),
      }
    : {
        ...(batchInformation?.walletName && {
          label: t('massPayouts.payingFromWallet'),
          value: `${batchInformation?.walletName} (${batchInformation?.walletNameCurrency})`,
        }),
      }

  const batchDetails = [
    {
      label: t('massPayouts.batchId'),
      value: batchInformation?.batchName,
    },
    ...(batchInformation?.totalAmount
      ? [
          {
            label: t('massPayouts.totalProcessedAmount'),
            value: `${batchInformation?.totalAmount} ${batchInformation?.totalAmountCurrency}`,
          },
        ]
      : []),
    ...(batchInformation?.totalFee !== undefined
      ? [
          {
            label: t('massPayouts.totalBatchFees'),
            value: `${batchInformation?.totalFee} ${batchInformation?.totalFeeCurrency}`,
          },
        ]
      : []),
    payingFromWallet,
  ]

  if (loading) {
    return <RowsSkeletonLoader rows={1} />
  }

  return (
    <Card variant="static" emphasis full>
      <Box flex className="w-full flex-wrap md:flex-nowrap">
        {batchDetails?.map(item => (
          <DataListItem
            key={item?.value}
            id={item?.value}
            title={item?.label}
            body={item?.value}
            layout="vertical"
          />
        ))}
      </Box>
    </Card>
  )
}
